import './language-switcher.css';
